import React, { useState, useCallback } from 'react';

import { DriverTipInput } from './index';
import { useFulfillmentPlannerContext } from '../../context';

export const CSWDrivenInput = () => {
  const {
    driverTip: { code, value },
    onDriverTipChange,
  } = useFulfillmentPlannerContext();
  const [currencyValue, setCurrencyValue] = useState(value);

  const onBlur = useCallback(() => {
    onDriverTipChange(currencyValue);
  }, [currencyValue, onDriverTipChange]);

  const onChange = useCallback((newValue) => {
    const parsedValue = Number.parseFloat(newValue);
    const driverTipValue = Number.isNaN(parsedValue) ? 0 : parsedValue;
    setCurrencyValue(driverTipValue);
  }, []);
  return <DriverTipInput currencyCode={code} currencyValue={currencyValue} onBlur={onBlur} onChange={onChange} />;
};
